import { render, staticRenderFns } from "./StatementDetail.vue?vue&type=template&id=4a02758d&scoped=true"
import script from "./StatementDetail.vue?vue&type=script&lang=js"
export * from "./StatementDetail.vue?vue&type=script&lang=js"
import style0 from "./StatementDetail.vue?vue&type=style&index=0&id=4a02758d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a02758d",
  null
  
)

export default component.exports